import * as actionTypes from './actionTypes';

const initialState = {
  activeSpaceId: null,
  ids: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
    case actionTypes.FETCH_ALL_FOR_ALL_FOLDER_TREES_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.SET_ACTIVE_SPACE_ID:
      return {
        ...state,
        activeSpaceId: action.id,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.space.id],
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== action.id),
        activeSpaceId: action.id === state.activeSpaceId ? null : state.activeSpaceId,
      };
    default:
      return state;
  }
};
